/*
 *
 * Selectors for GiftCardCart
 *
 */

import { createSelector } from 'reselect';
import { immutableToJS } from '../../devUtils/commonUtils';

const selectGiftCardCartDomain = (state) => state.get('giftCardCartPage');
const selectGiftCardCart = () => createSelector(
  selectGiftCardCartDomain,
  (giftCardCartPage) => giftCardCartPage,
);

const cartItemList = () => createSelector(
  selectGiftCardCartDomain,
  // (GiftCardCart) => GiftCardCart.get('cart_obj').toJS(),
  (giftCardCartPage) => immutableToJS(giftCardCartPage.get('cart_obj')),
);

const deleteCartItemStatus = () => createSelector(
  selectGiftCardCartDomain,
  (giftCardCartPage) => giftCardCartPage.get('delete_status'),
);

const getAddtoCartResponse = () => createSelector(
  selectGiftCardCartDomain,
  (giftCardCartPage) => immutableToJS(giftCardCartPage.get('addToCart')),
);

/**
 * @todo check dependency or remove @func userAddress @deprecated
 */
const userAddress = () => createSelector(
  selectGiftCardCartDomain,
  (giftCardCartPage) => immutableToJS(giftCardCartPage.get('address_user')),
);

const deleteAddressStatus = () => createSelector(
  selectGiftCardCartDomain,
  (giftCardCartPage) => giftCardCartPage.get('delete_address'),
);

const isLoading = () => createSelector(
  selectGiftCardCartDomain,
  (giftCardCartPage) => giftCardCartPage.get('isLoading'));

const select_isBoolean = (key) => createSelector(
  selectGiftCardCartDomain,
  (giftCardCartPage) => giftCardCartPage.get(key),
);

export { selectGiftCardCart, cartItemList, deleteCartItemStatus, userAddress, getAddtoCartResponse, isLoading, deleteAddressStatus, select_isBoolean };



// WEBPACK FOOTER //
// client/containers/GiftCardCart/selectors.js